<div class="module-wrapper content-wrapper" *ngIf="roleSer.accessData && (roleSer.accessData.viewAllowed || roleSer.accessData.insertAllowed)">
  <mat-card>
    <mat-card-content>
      <div class=" head-container">
        <h1>{{'roles.heading' | translate}}</h1>
        <!-- <div (mouseover)="isHidden = true">
          <img class="trainingIcon" src="../../../assets/favicon/video.png">
        </div>
        <div class="popupHover">
          <ng-container *ngIf="isHidden">
            <div class="hideshow">
              <a (click)="open_in_new_window('location=1,status=1,toolbar=1,resizeable=1,width=350,height=300', '../../../assets/video/test-delivery.mp4');">Create Item </a><br>
              <a (click)="open_in_new_window('location=1,status=1,toolbar=1,resizeable=1,width=350,height=300', '../../../assets/video/Sparkplug_TD.mp4');">Update Item</a>
            </div>
          </ng-container>
        </div> -->
      </div>

      <div class="itemBtn">
        <span class="spacer"></span>
        <div>
          <div class="btn-wrapper">
            <button mat-flat-button color="" class="btn-warn" aria-label="Add Role" (click)="addRole()"
              [disabled]="(roleSer.accessData?!roleSer.accessData.insertAllowed :true)">
              <span>+ {{'roles.btnAdd' | translate}}</span>
            </button>
          </div>
        </div>
      </div>
      <div class="input-container">
        <div class="input-fields-wrapper">
          <div class="input-wrapper">
            <input type="text" placeholder="{{'roles.inputName' | translate}}" [(ngModel)]="roleName" class="form-control ng-untouched ng-pristine ng-valid"
              ng-reflect-model="" filterValidator="Name">
            <input type="text" placeholder="{{'roles.inputDescription' | translate}}" [(ngModel)]="roleDescription" class="form-control ng-untouched ng-pristine ng-valid"
              ng-reflect-model="" filterValidator="Description">
          </div>
          <div class="btn-wrapper">
            <button mat-flat-button color="" class="btn-primary" (click)="roleFilter()" aria-label="Search">{{'roles.btnSearch' | translate}}</button>
            <button mat-flat-button color="" class="btn-flat" (click)="resetFilter()" aria-label="Reset">
              {{'roles.btnReset' | translate}}</button>
          </div>
        </div>
      </div>

      <div *ngIf="noDataFound" class="data-not-found-container table-container">
        <span>{{'roles.errorMsg' | translate}}</span>
      </div>
      <div class="d-none" [class.d-block]="dataSource" *ngIf="!noDataFound">
        <div class="table-container">
          <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
            <ng-container matColumnDef="role">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'roles.column1' | translate}}</th>
              <td mat-cell *matCellDef="let row">
                <ng-container *ngIf="row.role?.length > 40 then sliceTitle else noSliceTitle">
                </ng-container>

                <ng-template #sliceTitle>
                  <div class="text-bold" matTooltipClass="my-custom-tooltip" matTooltip="{{row.role}}" matTooltipPosition="above">
                    {{row.role | slice: 0:40}}...</div>
                </ng-template>
                <ng-template #noSliceTitle>
                  <div class="text-bold">{{row.role }}</div>
                </ng-template>

                <ng-container *ngIf="row.roledescription?.length > 40 then sliceDescription else noSliceDescription">
                </ng-container>
                <ng-template #sliceDescription>
                  <div matTooltipClass="my-custom-tooltip" matTooltip="{{row.roledescription}}" matTooltipPosition="above" class="description-text">
                    {{row.roledescription | slice: 0:40}}...</div>
                </ng-template>
                <ng-template #noSliceDescription>
                  <div class="description-text">{{row.roledescription }}</div>
                </ng-template>

                <!-- <span class="text-bold">{{row.role}}</span>
                <span>{{row.roledescription}}</span> -->
              </td>
            </ng-container>
            <ng-container matColumnDef="rolePrivileges">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'roles.column2' | translate}}</th>
              <td mat-cell *matCellDef="let row">{{row.rolePriviledges}}</td>
            </ng-container>
            <ng-container matColumnDef="roleUpdated">
              <th mat-header-cell *matHeaderCellDef [resizeColumn]="true">{{'roles.column3' | translate}}</th>
              <td mat-cell *matCellDef="let row">
                <div class="text-bold"> {{row.updatedBy}}</div>
                <div> {{row.updatedDate | dateAgo}}</div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr class="pointer" mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="row.role != AccountAdminRole ? 'pointer' : ''"
              (click)="row.role != AccountAdminRole ? navigateToRoles(row.roleId) : ''">
            </tr>
          </table>
        </div>
        <div class="roles-paginator">
          <mat-paginator #paginator [pageSizeOptions]="[10, 50, 100]" showFirstLastButtons></mat-paginator>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
